<template>
  <div style="height: 100%" class="pa-4">
    <application-notification :show="!getUser.prompted" text="Ensure to provide accurate UTME details in this section. Kindly note that editing will not be allowed"></application-notification>
    <v-form ref="form" v-model="dataValid">
      <v-row>
        <div class="error white--text pa-4 rounded-lg mb-4 text-center" style="width: 100%">
        <span v-if="getUser != null && getUser.admission.applicationType.autoLoadUtme">
          Check that the information below corresponds to yours.
        </span>
          <span v-else>
          Please submit accurate information since no modification will be permitted after submission.
        </span>
        </div>
      </v-row>
      <v-row style="background-color: white" class="rounded-lg my-2">
        <v-col cols="12" md="4">
          <v-autocomplete label="UTME Year" :disabled="!canEdit" :items="years" v-model="obj.year"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4 ml-md-8">
          <v-text-field label="UTME Reg." v-model="obj.jambRegNumber" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="space-between" style="background-color: white" class="rounded-lg my-2">
        <!--    first subject    -->
        <v-col cols="12" md="4">
          <div class=" font-weight-bold mt-8">First</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete  item-text="name" item-value="id" :items="subjects" label="Subject 1" :rules="textRules" required v-model="obj.subject1" :disabled="!canEdit"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number"  label="Score" :rules="textRules" required v-model="obj.score1" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="space-between" style="background-color: white" class="rounded-lg my-2">
        <!--    second subject    -->
        <v-col cols="12" md="4">
          <div class=" font-weight-bold mt-8">Second</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete  item-text="name" item-value="id" :items="subjects" label="Subject 2" :rules="textRules" required v-model="obj.subject2" :disabled="!canEdit"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number"  label="Score" :rules="textRules" required v-model="obj.score2" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="space-between" style="background-color: white" class="rounded-lg my-2">
        <!--    third subject    -->
        <v-col cols="12" md="4">
          <div class=" font-weight-bold mt-8">Third</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete  item-text="name" item-value="id" :items="subjects" label="Subject 3" :rules="textRules" required v-model="obj.subject3" :disabled="!canEdit"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number"  label="Score" :rules="textRules" required v-model="obj.score3" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="space-between" style="background-color: white" class="rounded-lg my-2">
        <!--    fourth subject    -->
        <v-col cols="12" md="4">
          <div class=" font-weight-bold mt-8">Fourth</div>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete  item-text="name" item-value="id" :items="subjects" label="Subject 4" :rules="textRules" required v-model="obj.subject4" :disabled="!canEdit"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field type="number"  label="Score" :rules="textRules" required v-model="obj.score4" :disabled="!canEdit"></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <v-card-actions class="mt-6 px-0">
      <v-btn color="basic" width="10em" class="white--text" @click="$emit('back')" depressed>{{  noHeader ? 'Back' : "Previous" }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primaryLight" width="10em" depressed @click="saveData" :disabled="!dataValid" v-if="canEdit" style="color: white"><v-icon>mdi-content-save</v-icon>{{  noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn color="info" width="10em" depressed @click="success" v-if="userData != null">Skip</v-btn>
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>
<script>

import ValidationRules from "@/shared/ValidationRules";
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import DateUtil from "@/shared/DateUtil";
import {mapGetters} from "vuex";
import ApplicationNotification from "@/application/pages/lafia/components/ApplicationNotification.vue";

export default {
  name: "UTMEDetails",
  props: {
    noHeader: Boolean
  },
  components: {ApplicationNotification, MessageBox, LoadingDialog},
  data () {
    return {
      obj: {
        year: null
      },
      subjects: [],
      textRules: ValidationRules.textRules,
      numberRules: ValidationRules.numericRules,
      userData: null,
      dataValid: true,
      messageType: '',
      message: '',
      messageShow: false,
      loading: false,
      years: DateUtil.getYearsArray(2015).reverse(),
      // this property is required to enabled modification of fields when preloading
      enableEdit: false,
    }
  },
  methods: {
    success() {
      this.$emit('success')
    },

    loadSubjects(){
      this.loading = true
      Api.requirements.getSubjects()
          .then(res => this.subjects = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    saveData(){
      this.loading = true
      Api.applicants.utmeUpdate(this.getUser.id, this.obj)
          .then(() => {
            this.message = 'UTME details updated'
            this.messageType = 'success'
            this.messageShow = true
            this.success()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadUTMEDetails(){
      this.loading = true
      Api.applicants.getUTMEDetails(this.getUser.userId)
          .then(res => {
            this.userData = res.data
            this.prefillData()
          })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    check() {
      this.loading = true;
      Api.applicants.nextToUTMEUpdate(this.getUser.id).then((res) => {
        this.loading = false;
        this.$store.commit("setUTMEDetails", res.data);
      }).catch((err) => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loading = false)
    },

    checkRequirement(){
      return this.getUser != null && (!this.getUser.admission.applicationType.utmeDetailsEnabled ||  (this.getUser.modeOfEntry != null &&  !this.getUser.modeOfEntry.requireUtmeScores))
    },

    prefillData(){
      this.enableEdit = true
      if(this.userData != null){
        let u = this.userData
        this.obj.year = +u.year
        this.obj.jambRegNumber = u.jambRegNumber
        this.obj.subject1 = u.subject1.id
        this.obj.subject2 = u.subject2.id
        this.obj.subject3 = u.subject3.id
        this.obj.subject4 = u.subject4.id
        this.obj.score1 = u.score1
        this.obj.score2 = u.score2
        this.obj.score3 = u.score3
        this.obj.score4 = u.score4
      }
      // lock back
      this.enableEdit = false
    }
  },

  watch:{
    getUser: function(){
      if(this.checkRequirement()) {
        this.success()
        return
      }

      if(this.getUser != null)
        this.loadUTMEDetails()
    },

    userData: function(val){
      if(val != null){
        // this.success()
      }
    }
  },

  computed: {
    ...mapGetters(['getUser', 'getInformation']),
    canEdit: function(){
      return (this.getUser != null && this.getUser.admission.applicationType.autoLoadUtme === false) || this.enableEdit
    }
  },

  created() {
    if(this.checkRequirement()) {

      this.success()
      return
    }



    if(this.getUser != null) {
      this.check();
      this.loadUTMEDetails()
    }


    this.loadSubjects()
    this.noHeader && this.$emit('update-title', "UTME Details")
  }
}
</script>

<style scoped>
.v-text-field >>> .v-input__slot::before  { border-color: #ECBD44 !important; border-width: .01em; border-radius: .006em; }
</style>
